<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="showFromAlarm ? 'required' : config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(config.name) }}
      </label>
      <v-select
        v-if="!loading"
        v-model="model"
        :options="itemsOptions"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="alarm_panel_id"
        :multiple="multiple"
        @input="$emit('input', model)"
      />
      <p v-else>Loading...</p>
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
    <!--    <div class="form-group form-check mt-1" v-if="showFromAlarm">-->
    <!--      <validation-provider vid="units_from_alarm">-->
    <!--        <input-->
    <!--          type="checkbox"-->
    <!--          class="form-check-input"-->
    <!--          name="units_from_alarm"-->
    <!--          v-model="fromAlarm"-->
    <!--          value="from_alarm"-->
    <!--        />-->
    <!--      </validation-provider>-->
    <!--      <label class="form-check-label">-->
    <!--        {{ $t("commands.form.location.fields.from_alarm") }}-->
    <!--      </label>-->
    <!--    </div>-->
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import axios from "@/libs/axios";

const proxyModels = [
  {
    model: 'alarm_panels',
    label: 'commands.form.alarm_panels.label',
  }
]

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      items: [],
      options: [],
      fromAlarm: false,
      showFromAlarm: false,
      proxyModels,
      loading: true,
    };
  },
  created() {
    this.showFromAlarm = this.context.flowchartConfig.alarm_compatible;
    this.model = this.value || null;
    this.fromAlarm = this.showFromAlarm && this.value === "from_alarm";
  },
  async mounted() {
    await this.fetchAlarmPanelDevices(this.context.model.alarm_panel_id);
  },
  watch: {
    fromAlarm: {
      handler(value) {
        if (value) {
          this.$emit("input", "from_alarm");
          this.model = null;
        } else {
          this.$emit("input", null);
        }
      },
    },
    "context.model.alarm_panel_id": {
      handler(value) {
        this.handlePanelUpdates(value);
      },
    }
  },
  computed: {
    itemsOptions() {
      if (this.options.length) {
        return this.options;
      }

      this.options = [...this.items];

      return this.options;
    },
  },
  methods: {
    async fetchAlarmPanelDevices(panelId) {
      if (!panelId || panelId === 'from_alarm') {
        this.loading = false;

        if (panelId === 'from_alarm') {
          this.generateAlarmPanelDevices();
        }

        return;
      }

      this.loading = true;
      const {data} = await axios.get(`/v1/services/alarm-panel/info?device_proxy_id=${panelId}&withDevices=true`);
      this.items = []

      data.data.devices.forEach((item) => {
        this.items.push({
          value: `${item.text}`,
          label: `${item.text}`,
        });
      });

      this.loading = false;
    },
    handlePanelUpdates(value) {
      this.options = [];
      this.items = [];
      this.model = null;
      this.fetchAlarmPanelDevices(value);
    },
    generateAlarmPanelDevices() {
      const size = 40;
      const list = [];
      for (let i = 0; i < 20; i++) {
        list.push(`PGM${i}`);
      }

      for (let i = 1; i <= size; i++) {
        list.push({
          value: `Input ${i}`,
          label: `Input ${i}`,
        });
      }

      this.items = list;
    }
  }
};
</script>

<style></style>
